var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "View",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.365,
    height: 15.854,
    viewBox: "0 0 20.365 15.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72205",
    "data-name": "Path 72205",
    d: "M21.75,10.4A11.23,11.23,0,0,0,12.185,4.66,11.23,11.23,0,0,0,2.62,10.4a4.191,4.191,0,0,0,0,4.379,11.23,11.23,0,0,0,9.565,5.737,11.248,11.248,0,0,0,9.565-5.737A4.191,4.191,0,0,0,21.75,10.4ZM20.3,13.885a9.594,9.594,0,0,1-8.114,4.931,9.594,9.594,0,0,1-8.114-4.931,2.483,2.483,0,0,1,0-2.606,9.594,9.594,0,0,1,8.114-4.922A9.581,9.581,0,0,1,20.3,11.288a2.468,2.468,0,0,1,0,2.6Z",
    transform: "translate(-2.003 -4.66)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72206",
    "data-name": "Path 72206",
    d: "M13.244,9a4.244,4.244,0,1,0,4.244,4.244A4.245,4.245,0,0,0,13.244,9Zm0,6.79a2.546,2.546,0,1,1,2.546-2.546A2.543,2.543,0,0,1,13.244,15.79Z",
    transform: "translate(-3.061 -5.317)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.c6e0e6ba961ae5585fd6f94edf03b9e9.svg";
export { ForwardRef as ReactComponent };